import React from 'react';
import { Box } from '@mui/material';
import HeroSlider from '../components/HeroSlider';
import VibeSection from '../components/VibeSection';

const Home = () => {
  return (
    <Box>
      <HeroSlider />
      <VibeSection />
    </Box>
  );
};

export default Home;
